import React from "react"
import FieldHelp from "../../help-and-hint/field-help/field-help";
import {MenuOption} from "./const";

export enum PopoverMenuOptionSelectionType {
    DEFAULT             = 'default',            // selection checkmark on the right
    LEFT                = 'left',               // selection checkmark on the left
    BOLD                = 'bold',
    BOLD_NO_CHECKMARK   = 'bold-no-checkmark',  // bold label, no selection checkmark - own class so BOLD's users are not tied to it
}

type Props = {

    id?             : string,
    className?      : string,
    highlightClass  : string

    option          : MenuOption,
    iconComponent?  : any,

    showArrow?      : boolean, // if true displays arrow like second level menu, or modal

    selected?       : boolean,
    isSelected?     : boolean,        // do we need it ???
    selectionType?  : PopoverMenuOptionSelectionType
    checkPro?       : boolean,
    disabled?       : boolean,
    isHighlighted?  : boolean,

    onMouseEnter?   : callbackOption,
    onMouseLeave?   : callbackOption,
    onClick?        : callback,
    onClickDisabled?: callback,
    onClickUpgrade? : callback,

    children?       : any,

    hidePopover?    : func              // if passed automatically close popover

}

// ! onClick param is OPTION (!) not id
// that is why PopoverMenuItem is depricated

export default class PopoverMenuOption extends React.Component<Props> {

    static defaultProps = {
        highlightClass: ''
    }

    _isDisabled = () => {
        const optionDisabled = typeof this.props.option.disabled === 'boolean' ? this.props.option.disabled : false
        return this.props.disabled || optionDisabled
    }

    onClick = (e:React.SyntheticEvent) => {

        e.stopPropagation()

        if (this.props.option?.isSelected) return;

        if (this._isDisabled()) {
            this.props.onClickDisabled && this.props.onClickDisabled()
            return
        }

        // close popover
        this.props.hidePopover && this.props.hidePopover()

        const proLicenseOnly = !!this.props.checkPro && !gd.company.license.isPro
        if (proLicenseOnly) {
            this.props.onClickUpgrade?.()
            return
        }

        // recommended
        if (this.props.option.onClick) {
            this.props.option.onClick()
            return
        }

        this.props.onClick && this.props.onClick(this.props.option)
    }

    onMouseEnter = (e:React.SyntheticEvent) => {
        this.props.onMouseEnter && this.props.onMouseEnter(this.props.option)
    }

    onMouseLeave = (e:React.SyntheticEvent) => {
        this.props.onMouseLeave && this.props.onMouseLeave(this.props.option)
    }

    renderIcon = ()=> {

        if (_.isNil(this.props.option.icon) || this.props.option.icon.length === 0) return null

        if (this.props.option.icon.startsWith("isvg")) {
            return <div className={Classes(this.props.option.icon, "w-14", "m-r-12")}/>
        } else {
            return <div className={Classes("ico", this.props.option.icon)}/>
        }

    }

    render() {
        const proLicenseOnly = !!this.props.checkPro && !gd.company.license.isPro

        const isSelected : boolean = !!this.props.selected || !!this.props.isSelected || !!this.props.option?.isSelected
        const selectionType = _.get(this.props, 'selectionType', PopoverMenuOptionSelectionType.DEFAULT)

        const classes = Classes('option', this.props.className, {
            'with-icon'                 : !_.isNil(this.props.option.icon),
            'disabled'                  : this._isDisabled(),
            'selected'                  : isSelected && selectionType === PopoverMenuOptionSelectionType.DEFAULT,
            'selected-left'             : isSelected && selectionType === PopoverMenuOptionSelectionType.LEFT,
            'selected-bold'             : isSelected && selectionType === PopoverMenuOptionSelectionType.BOLD,
            'selected-bold-no-checkmark': isSelected && selectionType === PopoverMenuOptionSelectionType.BOLD_NO_CHECKMARK,
            'highlighted'               : this.props.isHighlighted,
            [this.props.highlightClass] : this.props.isHighlighted
        })

        return (
            <div id             = {this.props.id}
                 className      = {classes}
                 onMouseDown    = {(e) => e.preventDefault()} // is REQUIRED for SAFARI to prevent undesired lexical focus lose (https://github.com/facebook/lexical/issues/5689)
                 onClick        = {this.onClick}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}>

                {this.renderIcon()}

                {this.props.iconComponent || this.props.option.iconComponent}
                <div className="label">{this.props.option.label}</div>

                {proLicenseOnly && <div className="ui5-ico-pro"/>}

                {/* one right-aligned slot - two `flex-1` siblings would split the leftover space between them */}
                {(!_.isNil(this.props.option.counter) || !!this.props.option.hint) &&
                    <div className="flex-row-right-center flex-1 m-l-10">
                        {!_.isNil(this.props.option.counter) &&
                            <div className="ui5-counter gray-v2">
                                {this.props.option.counter}
                            </div>
                        }

                        {!!this.props.option.hint &&
                            <FieldHelp
                                className   = "option-hint m-l-8"
                                message     = {this.props.option.hint}
                            />
                        }
                    </div>
                }

                {this.props.showArrow &&
                    <div className="submenu-arrow i5-big-angle-right"/>
                }

                {this.props.children}
            </div>
        )
    }
}
